"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var context_1 = __importDefault(require("../Map/context"));
var context_2 = __importDefault(require("./context"));
function Circle(props) {
    var map = React.useContext(context_1.default).map;
    var circle = React.useMemo(function () {
        var options = {
            center: new kakao.maps.LatLng(props.center.lat, props.center.lng),
            radius: props.radius,
            zIndex: props.zIndex,
            fillColor: props.fillColor,
            fillOpacity: props.fillOpacity,
            strokeColor: props.strokeColor,
            strokeWeight: props.strokeWeight,
            strokeOpacity: props.strokeOpacity,
            strokeStyle: props.strokeStyle,
        };
        var $circle = new kakao.maps.Circle(options);
        return $circle;
    }, []);
    React.useEffect(function () {
        circle.setMap(map);
        return function () { return circle.setMap(null); };
    }, []);
    var listeners = React.useRef({});
    listeners.current.onClick = function onClick(e) {
        var _a;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    listeners.current.onMouseMove = function onMouseMove(e) {
        var _a;
        (_a = props.onMouseMove) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    listeners.current.onMouseDown = function onMouseDown(e) {
        var _a;
        (_a = props.onMouseDown) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    listeners.current.onMouseOver = function onMouseOver(e) {
        var _a;
        (_a = props.onMouseOver) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    listeners.current.onMouseOut = function onMouseOut(e) {
        var _a;
        (_a = props.onMouseOut) === null || _a === void 0 ? void 0 : _a.call(props, {
            position: {
                lat: e.latLng.getLat(),
                lng: e.latLng.getLng(),
            },
        });
    };
    React.useEffect(function () {
        kakao.maps.event.addListener(circle, "click", listeners.current.onClick);
        kakao.maps.event.addListener(circle, "mousemove", listeners.current.onMouseMove);
        kakao.maps.event.addListener(circle, "mousedown", listeners.current.onMouseDown);
        kakao.maps.event.addListener(circle, "mouseover", listeners.current.onMouseOver);
        kakao.maps.event.addListener(circle, "mouseout", listeners.current.onMouseOut);
        return function () {
            kakao.maps.event.removeListener(circle, "click", listeners.current.onClick);
            kakao.maps.event.removeListener(circle, "mousemove", listeners.current.onMouseMove);
            kakao.maps.event.removeListener(circle, "mousedown", listeners.current.onMouseDown);
            kakao.maps.event.removeListener(circle, "mouseover", listeners.current.onMouseOver);
            kakao.maps.event.removeListener(circle, "mouseout", listeners.current.onMouseOut);
        };
    }, []);
    React.useEffect(function () {
        var latlng = new kakao.maps.LatLng(props.center.lat, props.center.lng);
        circle.setPosition(latlng);
    }, [props.center.lat, props.center.lng]);
    React.useEffect(function () {
        circle.setRadius(props.radius);
    }, [props.radius]);
    React.useEffect(function () {
        circle.setOptions({ fillColor: props.fillColor });
    }, [props.fillColor]);
    React.useEffect(function () {
        circle.setOptions({ fillOpacity: props.fillOpacity });
    }, [props.fillOpacity]);
    React.useEffect(function () {
        circle.setOptions({ strokeWeight: props.strokeWeight });
    }, [props.strokeWeight]);
    React.useEffect(function () {
        circle.setOptions({ strokeColor: props.strokeColor });
    }, [props.strokeColor]);
    React.useEffect(function () {
        circle.setOptions({ strokeOpacity: props.strokeOpacity });
    }, [props.strokeOpacity]);
    React.useEffect(function () {
        circle.setOptions({ strokeStyle: props.strokeStyle });
    }, [props.strokeStyle]);
    React.useEffect(function () {
        circle.setZIndex(props.zIndex);
    }, [props.zIndex]);
    return (React.createElement(context_2.default.Provider, { value: { circle: circle } }, props.children));
}
Circle.defaultProps = {
    radius: 10,
    fillColor: "transparent",
    fillOpacity: 1,
    strokeColor: "#000",
    strokeWeight: 1,
    strokeOpacity: 1,
    strokeStyle: "solid",
    zIndex: 0,
};
Circle.propTypes = {
    /** 맵에 표시될 좌표 */
    center: prop_types_1.default.shape({
        lat: prop_types_1.default.number.isRequired,
        lng: prop_types_1.default.number.isRequired,
    }).isRequired,
    /** 단위 : m */
    radius: prop_types_1.default.number,
    /** 채움 색 */
    fillColor: prop_types_1.default.string,
    /** 채움 색의 불투명도 ( 0 ~ 1 ) */
    fillOpacity: prop_types_1.default.number,
    /** 채움 색 */
    strokeColor: prop_types_1.default.string,
    /** 채움 불투명도 ( 0 ~ 1 ) */
    strokeOpacity: prop_types_1.default.number,
    /** 선의 두께 ( 단위 : px ) */
    strokeWeight: prop_types_1.default.number,
    /** 선 스타일 */
    strokeStyle: prop_types_1.default.oneOf(["solid", "shortdash", "shortdot", "shortdashdot", "shortdashdotdot", "dot", "dash", "dashdot", "longdash", "longdashdot", "longdashdotdot"]),
    /** z-index 속성 값 */
    zIndex: prop_types_1.default.number,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onClick: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onMouseDown: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onMouseMove: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onMouseOver: prop_types_1.default.func,
    /** (e: { position: { lat: number, lng: number } }) => void */
    onMouseOut: prop_types_1.default.func,
};
exports.default = Circle;
